<template>
    <div>
        <van-form label-width="70px" label-align="right">
            <van-divider content-position="left">洞见信息</van-divider>
            <van-cell-group inset>
                <van-field v-if="bjShowDetail" label="洞见编号：" v-model="dataForm.ldId" readonly/>
                <van-field label="洞见名称：" v-model="dataForm.ldName" readonly/>
                <van-field v-if="bjShowDetail" label="项目名称：" v-model="dataForm.sourceName" readonly/>
                <van-field label="申报部门：" v-model="dataForm.deptName" readonly/>
                <van-field label="申报人：" v-model="dataForm.declarePersonStr" readonly/>
                <van-field label="业务类别：" v-model="dataForm.businessType" readonly/>
                <van-field label="洞见类型：" v-model="dataForm.insightType" readonly/>
                <van-field v-if="bjShowDetail" label="洞见状态：" v-model="dataForm.statusStr" readonly/>
                <van-field v-if="dataForm.ldApprove&&bjShowDetail" label="会审结果：" v-model="dataForm.ldApprove" readonly/>
                <!-- <van-field label="业务简述：" v-model="dataForm.highlightsOverview" readonly type="textarea" autosize/> -->
                <van-cell>
                    <div style="font-weight:600;color:#646566;">业务简述：</div>
                    <div style="overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;text-overflow:ellipsis;white-space:pre-wrap;word-wrap:break-word;">{{dataForm.highlightsOverview}}</div>
                    <div style="text-align:right;color:#969799;cursor:pointer;">
                        <span @click="showDetail('业务简述：',dataForm.highlightsOverview)">查看详情</span>
                    </div>
                </van-cell>
                <van-cell v-if="dataForm.status < 30">
                    <div style="font-weight:600;color:#646566;">工作目标：</div>
                    <div style="overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;text-overflow:ellipsis;white-space:pre-wrap;word-wrap:break-word;">{{dataForm.workObjectives}}</div>
                    <div style="text-align:right;color:#969799;cursor:pointer;">
                        <span @click="showDetail('工作目标：',dataForm.workObjectives)">查看详情</span>
                    </div>
                </van-cell>
                <van-cell v-if="dataForm.status < 30">
                    <div style="font-weight:600;color:#646566;">关键结果：</div>
                    <div style="overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;text-overflow:ellipsis;white-space:pre-wrap;word-wrap:break-word;">{{dataForm.keyResults}}</div>
                    <div style="text-align:right;color:#969799;cursor:pointer;">
                        <span @click="showDetail('关键结果：',dataForm.keyResults)">查看详情</span>
                    </div>
                </van-cell>
            </van-cell-group>
            <van-divider content-position="left" v-if="bjShowDetail">洞察与建议</van-divider>
            <template v-if="bjShowDetail">
                <van-cell-group inset v-for="(item,index) in insights" :key="index">
                    <van-field :label="'洞察'+(index+1)+'：'" v-model="item.insight" readonly>
                        <template #button>
                            <div @click="showDetail('洞察'+(index+1)+'：',item.insight)" style="cursor:pointer;">
                            查看详情
                            </div>
                        </template>
                    </van-field>
                    <van-field :label="'建议'+(index+1)+'：'" v-model="item.advise" readonly>
                        <template #button>
                            <div @click="showDetail('建议'+(index+1)+'：',item.advise)" style="cursor:pointer;">
                                查看详情
                            </div>
                        </template>
                    </van-field>
                </van-cell-group>
            </template>
            <van-cell-group inset v-if="bjShowDetail">
                <van-cell style="cursor:pointer;">
                    <div style="font-weight:600;color:#646566;">整体建议：</div>
                    <div style="overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;text-overflow:ellipsis;white-space:pre-wrap;word-wrap:break-word;">{{dataForm.wholeAdvies}}</div>
                    <div style="text-align:right;color:#969799;">
                        <span @click="showDetail('整体建议：',dataForm.wholeAdvies)">查看详情</span>
                    </div>
                </van-cell>
            </van-cell-group>
            <van-divider content-position="left" v-if="bjShowDetail">认定条件</van-divider>
            <van-cell-group inset v-if="bjShowDetail">
                <template v-for="item in condition">
                    <van-cell v-if="matterJSON[item.value]" :key="item.value">
                        <!-- <div style="background-color:rgb(230 232 235);padding:2px 10px;border-radius: 2px;font-weight:600;">{{item.label}}：</div>
                        {{matterJSON[item.value]}} -->
                        <div style="font-weight:600;color:#646566;">{{item.label}}</div>
                        <div style="overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;text-overflow:ellipsis;white-space:pre-wrap;word-wrap:break-word;">{{matterJSON[item.value]}}</div>
                        <div style="text-align:right;color:#969799;cursor:pointer;">
                            <span @click="showDetail(item.label,matterJSON[item.value])">查看详情</span>
                        </div>
                    </van-cell>
                </template>
            </van-cell-group>
            <van-divider content-position="left" v-if="bjShowDetail">重要性评估</van-divider>
            <van-cell-group inset v-if="bjShowDetail">
                <template v-for="item in estimate">
                    <van-cell v-if="matterJSON[item.value]" :key="item.value">
                        <!-- <div style="background-color:rgb(230 232 235);padding:2px 10px;border-radius: 2px;font-weight:600;">{{item.label}}：</div>
                        {{matterJSON[item.value]}} -->

                        <div style="font-weight:600;color:#646566;">{{item.label}}</div>
                        <div style="overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;text-overflow:ellipsis;white-space:pre-wrap;word-wrap:break-word;">{{matterJSON[item.value]}}</div>
                        <div style="text-align:right;color:#969799;cursor:pointer;">
                            <span @click="showDetail(item.label,matterJSON[item.value])">查看详情</span>
                        </div>
                    </van-cell>
                </template>
            </van-cell-group>
            <van-divider content-position="left" v-if="reviewers.length>0&&bjShowDetail">评审结果</van-divider>
            <van-cell-group inset v-if="reviewers.length>0&&bjShowDetail">
                <van-cell v-for="item in reviewers" :key="item.guid" style="">
                    <div>
                        <div style="display:inline-block;line-height:20px;width:60px;text-align:right;padding-right:26px;">{{item.reviewerName}}</div>
                        <div style="display:inline-block;">
                            <van-radio-group v-model="item.reviewResult" direction="horizontal" v-if="curReview&&item.reviewerNo==curUserNo">
                                <van-radio name="通过">通过</van-radio>
                                <van-radio name="有条件通过">有条件通过</van-radio>
                                <van-radio name="不通过">不通过</van-radio>
                            </van-radio-group>
                            <!-- <span v-else :style="{color:item.reviewResult=='不通过'?'red':null}">
                                {{item.reviewResult}}
                            </span> -->
                            
                            <template v-else>
                                <span v-if="item.reviewResult=='通过'" style="color:#1989fa;">通过</span>
                                <span v-else-if="item.reviewResult=='有条件通过'" style="color:#07c160;">有条件通过</span>
                                <span v-else-if="item.reviewResult=='不通过'" style="color:#ee0a24;">不通过</span>
                            </template>
                            <span style="margin-left:20px;" v-if="item.reviewTimeStr">{{item.reviewTimeStr}}</span>
                        </div>
                    </div>
                    <van-field v-if="(curReview&&item.reviewerNo==curUserNo)||item.reason" style="padding:10px 0px;" :readonly="!(curReview&&item.reviewerNo==curUserNo)" name="建议" type="textarea" label="建议：" v-model="item.reason" :placeholder="(curReview&&item.reviewerNo==curUserNo)?'请填写建议':''" rows="1" autosize maxlength="1000"/>
                </van-cell>
                <van-cell>
                    <div style="color:#646566;font-weight: 600;">会审统计：</div>
                    <span style="color:#1989fa;">通过：{{reviewTgCount}}</span>
                    <span style="color:#07c160;margin-left:5vw;">有条件通过：{{reviewTjTgCount}}</span>
                    <span style="color:#ee0a24;margin-left:5vw;">不通过：{{reviewNoTgCount}}</span>

                    <!-- <van-tag plain size="large" type="primary">通过：{{reviewTgCount}}</van-tag>
                    <van-tag plain size="large" type="success" style="margin-left:10px;">有条件通过：{{reviewTjTgCount}}</van-tag>
                    <van-tag plain size="large" type="danger" style="margin-left:10px;">不通过：{{reviewNoTgCount}}</van-tag> -->
                </van-cell>
                <van-field v-if="dataForm.ldOpinion||(actTask.curTaskTitle=='审计监察总监'&&actTask.isTask)" :readonly="!(actTask.curTaskTitle=='审计监察总监'&&actTask.isTask)" type="textarea" label="评审意见：" v-model="dataForm.ldOpinion" :placeholder="(actTask.curTaskTitle=='审计监察总监'&&actTask.isTask)?'请输入您的建议与意见':''" rows="2" autosize maxlength="1000"/>
            </van-cell-group>

            <van-divider v-if="dataForm.status >= 30" content-position="left">进展信息</van-divider>
            <van-cell-group v-if="dataForm.status >= 30" inset>
                <van-cell>
                    <div style="font-weight:600;color:#646566;">工作目标：</div>
                    <div style="overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;text-overflow:ellipsis;white-space:pre-wrap;word-wrap:break-word;">{{dataForm.workObjectives}}</div>
                    <div style="text-align:right;color:#969799;cursor:pointer;">
                        <span @click="showDetail('工作目标：',dataForm.workObjectives)">查看详情</span>
                    </div>
                </van-cell>
                <van-cell>
                    <div style="font-weight:600;color:#646566;">关键结果：</div>
                    <div style="overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;text-overflow:ellipsis;white-space:pre-wrap;word-wrap:break-word;">{{dataForm.keyResults}}</div>
                    <div style="text-align:right;color:#969799;cursor:pointer;">
                        <span @click="showDetail('关键结果：',dataForm.keyResults)">查看详情</span>
                    </div>
                </van-cell>
                <van-field label-width="100" label="落地金额(万)：" label-align="left" v-model="dataForm.landingAmount" readonly/>
                <van-cell>
                    <div style="font-weight:600;color:#646566;">进展概述：</div>
                    <div style="overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;text-overflow:ellipsis;white-space:pre-wrap;word-wrap:break-word;">{{dataForm.progressOverview}}</div>
                    <div style="text-align:right;color:#969799;cursor:pointer;">
                        <span @click="showDetail('进展概述：',dataForm.progressOverview)">查看详情</span>
                    </div>
                </van-cell>
            </van-cell-group>
        </van-form>
        <div v-if="curReview" center style="margin:20px;">
            <van-button style="margin:0 10px;padding: 0px 20px;" plain size="small" round type="info" loading-text="加载中。。。" :loading="loading" @click="save">保存</van-button>
            <van-button style="margin:0 10px;padding: 0px 20px;" plain size="small" round type="info" loading-text="加载中。。。" :loading="loading" @click="onSubmit">提交</van-button>
        </div>
        <div v-if="(actTask.curTaskTitle=='审计监察总监'&&actTask.isTask)" center style="margin:20px;">
            <van-button style="margin:0 5px;padding: 0px 20px;" plain size="small" round type="info" loading-text="加载中。。。" :loading="loading" @click="noPassThrough">不通过</van-button>
            <van-button style="margin:0 5px;padding: 0px 20px;" plain size="small" round type="info" loading-text="加载中。。。" :loading="loading" @click="updatePassThrough">驳回</van-button>
            <van-button style="margin:0 5px;padding: 0px 20px;" plain size="small" round type="info" loading-text="加载中。。。" :loading="loading" @click="passThrough">通过</van-button>
        </div>
        <!-- <div style="height:20px;"></div> -->
        <van-popup v-model="highlightsOverviewShow" position="bottom" :style="{height:'70%'}" round>
            <van-cell style="padding:20px;text-align:left;">
                <div style="font-weight:600;">{{detailTitle}}</div>
                <!-- <van-field autosize type="textarea" v-model="detailContent"/> -->
                <!-- <pre>{{detailContent}}</pre> -->
                <div style="white-space:pre-wrap;word-wrap:break-word;">{{detailContent}}</div>
            </van-cell>
        </van-popup>
        <div style="text-align:center;color:#969799;cursor:pointer;margin-top:20px;" v-if="dataForm.status >= 30">
            <!-- <span v-if="bjShowDetail" @click="bjShowDetail=!bjShowDetail">隐藏洞见信息</span>
            <span v-else @click="bjShowDetail=!bjShowDetail">展示洞见信息</span> -->

            <van-icon v-if="bjShowDetail" @click="bjShowDetail=!bjShowDetail" name="arrow-up" size="24"></van-icon>
            <van-icon v-else @click="bjShowDetail=!bjShowDetail" name="arrow-down" size="24"></van-icon>
        </div>
        <AppWorkFlow
            ref="workFlow"
            @cancelApproval="cancelApproval"
            @sendWorkFlow="sendWorkFlow"
            @taskEvent="taskEvent"
            :workFlowGuid="workFlowGuid"
            :workFlowFormKey="workFlowFormKey"
            :notSendMsg="actTask.afterTaskTitle=='会审人员'||actTask.afterTaskTitle=='审计监察总监'"
            :showWorkFlow="!(dataForm.status<30&&(actTask.curTaskTitle=='办公室主任'||actTask.curTaskTitle=='会审人员'||actTask.curTaskTitle=='审计监察总监'))"
            :sendFsApprove="!(actTask.afterTaskTitle=='会审人员'||actTask.afterTaskTitle=='审计监察总监'||(dataForm.status<=20&&actTask.afterTaskTitle=='办公室主任'))"
            :workFlowFormData="dataForm"
            :workFlowFormVar="workFlowFormVar"
        />
    </div>
    
</template>
<script>
import AppWorkFlow from '@/plugins/AppWorkFlow'
export default {
    components:{
        AppWorkFlow
    },
    data(){
        return {
            bjShowDetail:true,
            workFlowFormVar:{highlightStatus:10},
            reviewTgCount:0,
            reviewTjTgCount:0,
            reviewNoTgCount:0,
            detailTitle:'',
            detailContent:'',
            highlightsOverviewShow:false,
            curUserNo:'',
            insights:[],
            actTask:{},
            showSaveButton:false,
            reviewerSaveStr:'',
            workFlowGuid:'',
            workFlowFormKey:'HIGHLIGHT_ACHIEVEMENTS',
            curReview:false,
            dataForm:{},
            reviewers:[],
            matterJSON:{},
            condition:[
                {value:'100',label:'1.透过现象看到真相、本质、规律等'},
                {value:'101',label:'2.找到业务痛点、瓶颈、风险点等'},
                {value:'102',label:'3.找到业务改善与发展机会点'},
                {value:'103',label:'4.找到问题深层次建议，驱动因素与影响'},
                {value:'104',label:'5.提出独特见解和观点'},
                {value:'105',label:'6.提出创新有效解决方案'},
                {value:'106',label:'7.看到问题各自可能性和风险'},
            ],
            estimate:[
                {value:'200',label:'1.影响范围大'},
                {value:'201',label:'2.解决重大或普遍问题'},
                {value:'202',label:'3.增收节支、挽回损失或规避风险金额≥100万元'},
                {value:'203',label:'4.新的解决方案或观点'},
                {value:'204',label:'5.长期可持续性产生收益'},
                {value:'205',label:'6.满足当前或未来相关领域需求'},
            ],
            
            businessType:{
                '100':'营销',
                '101':'商务',
                '102':'财务',
                '103':'基建',
                '104':'制造',
                '105':'其他',
            },
            insightType:{
                '200':'问题类',
                '201':'风险类',
                '202':'机会类',
                '203':'解决方案类',
            },
            loading:false,
            status:{
                '10':'草稿',
                '20':'申请审批中',
                '30':'执行',
                '40':'办结审批中',
                '50':'办结',
                '60':'无效'
            }
        }
    },
    created(){
        this.curUserNo = this.$userNo()
        document.title='洞见详情'
        this.initData()
    },
    mounted(){
    },
    methods:{
        async saveInsights(formGuid){
            this.insights = this.insights.map(item=>{
                item.ldGuid = formGuid||this.dataForm.guid
                return item
            })
            await this.$http.post('/api/job/v0.1/highlightsInsight/saves',this.insights)
            .then(async res=>{
                
            })
            .catch((err)=>{
            })
        },
        async saveHistoryVersion(){
            let copyForm = JSON.parse(JSON.stringify(this.dataForm))
            copyForm.backGuid = copyForm.guid
            copyForm.guid = undefined
            copyForm.implementWorkFlowGuid = undefined
            copyForm.finishWorkFlowGuid = undefined
            copyForm.versionTime = new Date().getTime()
            copyForm.ishow = -1
            await this.$http.post('/api/job/v0.1/highlightsAchievements/save',copyForm)
            .then(async res=>{
                copyForm = res.data
                await this.saveInsights(res.data.guid)
                await this.$http.post('/api/job/v0.1/highlightsAchievements/saveHighlightsReviewDatas',{
                    guid:res.data.guid,
                    highlightsReviews:this.reviewers
                })
            })
            .catch((err)=>{
                this.$message.error('操作失败')
            })
        },
        showDetail(title,content){
            this.detailTitle = title
            this.detailContent = content
            this.highlightsOverviewShow = true
        },
        getInsights(){
            this.$http.get('/api/job/v0.1/highlightsInsight/page',{
                params:{
                    ldGuid:this.dataForm.guid,
                    pageSize:100000
                }
            })
            .then(async res=>{
                this.insights = res.data.list.sort((a,b)=>{
                    return a.orderNum-b.orderNum
                })
            })
        },
        initData(){
            let guid = this.$route.query.guid
            this.$http.get('/api/job/v0.1/highlightsAchievements/'+guid)
            .then(res=>{
                res.data.statusStr = this.status[res.data.status]
                this.dataForm = res.data
                if(this.dataForm.finishWorkFlowGuid&&(!this.dataForm.finishTime)){
                    this.$set(this.workFlowFormVar,'highlightStatus',30)
                    this.workFlowGuid = this.dataForm.finishWorkFlowGuid
                }else if(this.dataForm.implementWorkFlowGuid&&(!this.dataForm.implementTime)){
                    if('驳回'==this.dataForm.ldApprove){
                        this.$set(this.workFlowFormVar,'highlightStatus',20)
                    }
                    this.workFlowGuid = this.dataForm.implementWorkFlowGuid
                }
                if(this.dataForm.status >= 30){
                    this.bjShowDetail = false
                }
                if(res.data.matter){
                    this.matterJSON = JSON.parse(res.data.matter)
                }
                this.getInsights()
                this.getReviewers()
            })
        },
        getReviewers(){
            // let reviewerNo = this.$userNo()
            // if(this.$userIsAdmin()||['00021724','21014531','80041432'].indexOf(reviewerNo)>-1||(this.actTask.isTask&&this.actTask.curTaskTitle=='办公室主任')||(this.actTask.isTask&&this.actTask.curTaskTitle=='审计监察总监')){
            //     reviewerNo = null
            // }
            this.$http.get('/api/job/v0.1/highlightsAchievements/queryHighlightsReview',{
                params:{
                    ldGuid:this.dataForm.guid,
                    // reviewerNo:reviewerNo,
                }
            }).then(res=>{
                if(res.data.length>0){
                    let reviewTgCount = 0
                    let reviewTjTgCount = 0
                    let reviewNoTgCount = 0
                    this.reviewers = res.data.map(item=>{
                        item.orderNum = 0
                        if(item.reviewResult=='待评审'){
                            item.orderNum = 1
                        }else if(item.reviewResult=='通过'){
                            item.orderNum = 2
                            reviewTgCount+=1
                        }else if(item.reviewResult=='有条件通过'){
                            item.orderNum = 3
                            reviewTjTgCount +=1
                        }else if(item.reviewResult=='不通过'){
                            item.orderNum = 4
                            reviewNoTgCount += 1
                        }
                        item.reviewTimeStr = this.$handlerDateToTime(item.reviewTime)
                        return item
                    }).sort((a,b)=>{
                        return a.reviewTime >= b.reviewTime?1:-1
                    })
                    
                    this.reviewTgCount = reviewTgCount
                    this.reviewTjTgCount = reviewTjTgCount
                    this.reviewNoTgCount = reviewNoTgCount
                }else{
                    this.reviewers = []
                }
                this.reviewerSaveStr = JSON.stringify(this.reviewer)
            })
        },
        save(){
            this.$http.post('/api/job/v0.1/highlightsAchievements/updateSelectHighlightsReviewById',this.reviewers.find(item=>item.reviewerNo==this.curUserNo))
            .then(async res=>{
                this.Toast.success('暂存成功')
                this.initData()
            }).catch(err=>{
                this.Toast.fail('暂存失败，请联系管理员，报错：'+err)
            })
        },
        onSubmit(){
            let curReviewe = this.reviewers.find(item=>item.reviewerNo==this.curUserNo)
            if('待评审'==curReviewe.reviewResult){
                return this.Dialog.alert({
                    title:'提示',
                    message:'请选择评审是否通过'
                })
            }
            if('不通过'==curReviewe.reviewResult&&!curReviewe.reason){
                return this.Dialog.alert({
                    title:'提示',
                    message:'选择不通过必须填写建议'
                })
            }
            if('有条件通过'==curReviewe.reviewResult&&!curReviewe.reason){
                return this.Dialog.alert({
                    title:'提示',
                    message:'请填写通过的条件'
                })
            }
            if(this.reviewerSaveStr != JSON.stringify(this.reviewer)){
                return this.Dialog.alert({
                    title:'提示',
                    message:'请先保存数据'
                })
            }
            this.Dialog.confirm({
                title:'提示',
                message:'请确认是否提交评审，评审后数据将不能修改。'
            }).then(()=>{
                this.$nextTick(()=>{
                    this.$http.post('/api/job/v0.1/highlightsAchievements/updateSelectHighlightsReviewById',curReviewe)
                    .then(async res=>{
                        this.$refs.workFlow.ACT_confirm()
                    })
                })
            })
        },
        
        taskEvent(task){
            this.$set(this,'actTask',JSON.parse(JSON.stringify(task)))
            if(task.curTaskTitle=='会审人员'&&task.isTask){
                this.curReview = true
            }else{
                this.curReview = false
            }
            // this.getReviewers()
        },
        sendWorkFlow(val){
            this.saveOrNo=false;
            this.$http.get('/api/job/v0.1/highlightsAchievements/updateStatus',{params:{guid:this.dataForm.guid,status:val,curApproveTitle:this.actTask.curTaskTitle,afterApproveUser:this.actTask.afterTaskUser,afterApproveTitle:this.actTask.afterTaskTitle}})
            .then(res=>{
                location.reload()
            })
        },
        cancelApproval(wfGuid){
            let form = {guid:this.dataForm.guid}
            if(this.dataForm.ldApprove=='不通过'){
                form.status = 60
            }else{
                form.status = this.dataForm.finishWorkFlowGuid?30:10
            }
            if(this.dataForm.finishWorkFlowGuid){
                form.finishWorkFlowGuid = ''
            }else{
                form.implementWorkFlowGuid = ''
            }
            this.$http.post('/api/job/v0.1/highlightsAchievements/save',form)
            .then(async res=>{
                // this.$message.success('废弃成功')
                window.location.reload()
            })
            .catch((err)=>{
                this.$message.error('废弃失败！请联系管理员')
            })
        },
        async saveOpinion(approve){
            if(!this.dataForm.ldApprove){
                this.dataForm.ldApprove = approve
            }
            await this.$http.post('/api/job/v0.1/highlightsAchievements/save',
            {
                guid:this.dataForm.guid,
                ldOpinion:this.dataForm.ldOpinion,
                ldOpinion:this.dataForm.ldOpinion,
                ldApprove:this.dataForm.ldApprove,
                implementTime:this.dataForm.implementTime
            }
            )
            .then(async res=>{
                this.hasSaveOpinion = this.dataForm.ldOpinion
            })
        },
        noPassThrough(){
            this.Dialog.confirm({
                title:'提示',
                message:'请确认当前操作，不通过后此洞见将置为无效'
            }).then(async ()=>{
                this.dataForm.implementTime = new Date().getTime()
                await this.saveOpinion('不通过')
                this.Toast.success('洞见已置为无效')
                this.$nextTick(()=>{
                    this.$refs.workFlow.directCancelApproval()
                })
            })
        },
        updatePassThrough(){
            this.Dialog.confirm({
                title:'提示',
                message:'请确认当前操作，是否驳回'
            }).then(async ()=>{
                await this.saveHistoryVersion()
                await this.saveOpinion('驳回')
                this.Toast.success('项目经理修改洞见后将生效')
                this.$nextTick(()=>{
                    this.$refs.workFlow.rejectToFast(this.dataForm.ldOpinion)
                })
            })
        },
        passThrough(){
            this.Dialog.confirm({
                title:'提示',
                message:'请确认当前操作，是否通过'
            }).then(async ()=>{
                await this.saveOpinion('通过')
                this.$nextTick(()=>{
                    this.$refs.workFlow.ACT_confirm(this.dataForm.ldOpinion)
                })
                this.Toast.success('洞见已生效')
            })
        },
    }
}
</script>

<style scoped>
.van-divider{
    font-size:16px;
    color: #323232;
}
</style>
